import React from 'react'
import { PullToRefresh, List, Toast } from 'antd-mobile'
import Checkbox from '@/components/checkbox/checkbox'
import { simpleDetailApi, confirmPayApi, payInfoApi } from '@/api/shopping-car'
import { withRouter } from 'react-router'
import ReactDOM from 'react-dom'
import './pay.less'
import { setHeader } from '@/util/set-header'
const Item = List.Item
const APullToRefresh: any = PullToRefresh
@(withRouter as any)
class Pay extends React.Component<any, any> {
  private timerID: any
  ptr!: PullToRefresh
  constructor(props: any) {
    super(props)
    this.state = {
      time: 9,
      pay_fee: 0,
      text: '确认支付',
      refreshing: false,
      //true 支付宝 false 微信
      paytype: true,
      height: document.documentElement.clientHeight - 45,
    }
    this.simpleDetail=this.simpleDetail.bind(this)
    this.goPay=this.goPay.bind(this)
    let that = this
    window.paySuccessBack = function() {
    const { props } = that
    // Toast.info('支付成功', 1)
    props.history.replace(`/order-list/0`)
    }
  }

  leftClick = () => {
    const { history, match } = this.props
    const fromPath = match.params.path
    if (fromPath === 'store') {
      history.replace(`/store`)
    } else {
      history.replace(`/order-list/0`)
    }
  }
  UNSAFE_componentWillMount() {
    setHeader({ title: '在线支付', leftClick: this.leftClick })
  }

  onRefresh = async () => {
    const { match } = this.props
    this.setState({ refreshing: true })
    await this.simpleDetail(match.params.order_sn)
    this.setState({ refreshing: false })
  }

  componentDidMount() {
    const { match } = this.props
    this.simpleDetail(match.params.order_sn)
    const height =
      document.documentElement.clientHeight -
      (ReactDOM.findDOMNode(this.ptr) as any).offsetTop -
      (document.querySelector('.nav-pay') as any).clientHeight
    this.setState({ height })
  }

  componentWillUnmount() {
    clearInterval(this.timerID)
  }
  //获取商品详情
  async simpleDetail (order_sn: string) {
    Toast.loading('加载中', 0)
    const { data } = await simpleDetailApi(order_sn)
    Toast.hide()
    if (data.code !== 'SUCCESS') {
      Toast.info(data.msg, 1)
      return
    }
    const info = data.data
    if (Number(info.save_time) <= 0) {
      // this.props.history.push({
      //   pathname: '/store',
      // })
      Toast.info('订单已失效', 1)
      this.props.history.goBack()
      return
    }

    await this.setState({
      time: info.save_time,
      pay_fee: info.pay_fee,
    })
    if (!this.timerID) {
      this.timerID = setInterval(() => this.tick(), 1000)
    }
  }
  paytypeChange = (paytype: boolean) => {
    this.setState({
      paytype: paytype,
    })
  }

  tick() {
    if (this.state.time > 0) {
      this.setState({
        time: this.state.time - 1,
      })
    } else {
      clearInterval(this.timerID)
      this.props.history.push({
        pathname: '/store',
      })
    }
  }
  async goPay ()  {
    const { match } = this.props
    let params = {
      order_sn: match.params.order_sn,
      pay_type: this.state.paytype ? 'alipay' : 'wechat',
    }
    Toast.loading('加载中', 0)
    const { data } = await confirmPayApi(params)
    Toast.hide()
    if (data.code !== 'SUCCESS') {
      Toast.info(data.msg, 1)
      return
    }
    const jumpInfo = data.data
    if (data.data.jump.jump_type === 'go_pay') {
      const { data } = await payInfoApi(jumpInfo.jump.jump_value)
      if (data.code !== 'SUCCESS') {
        Toast.info(data.msg, 1)
        return
      }
      if (this.state.paytype) {
        if (window.WebViewBridge) {
          window.WebViewBridge?.aliPay?.call(window.WebViewBridge, data.data)
        } else if (window.webkit) {
          window.webkit.messageHandlers.aliPay.postMessage(data.data)
        }
      } else {
        let dataString = JSON.stringify(data.data)
        if (window.WebViewBridge) {
          window.WebViewBridge?.weChatPay?.call(window.WebViewBridge, dataString)
        } else if (window.webkit) {
          window.webkit.messageHandlers.weChatPay.postMessage(dataString)
        }
      }
    } else {
      let jump = {
        jump_type: jumpInfo.jump.jump_type,
        jump_value: jumpInfo.jump.jump_value,
      }
      if (window.WebViewBridge) {
        window.WebViewBridge?.goToPage?.call(window.WebViewBridge, jump)
      } else if (window.webkit) {
        window.webkit.messageHandlers.goToPage.postMessage(jump)
      }
    }
  }

  render() {
    let minNum = Math.floor(this.state.time / 60)
    let minute = minNum < 10 ? `0${minNum}` : minNum

    let secondNum = Math.floor(this.state.time % 60)
    let second = secondNum < 10 ? `0${secondNum}` : secondNum
    return (
      <div className="pay">
        <APullToRefresh
          refreshing={this.state.refreshing}
          onRefresh={this.onRefresh}
          ref={(el: any) => (this.ptr = el)}
          style={{
            height: this.state.height,
            overflow: 'auto',
          }}
        >
          <div className="pay-select">
            <div className="time"> {`${minute}:${second}`}</div>
            <List renderHeader={() => '选择支付方式'}>
              <Item>
                <div onClick={() => this.paytypeChange(true)} className="item">
                  <div>
                    <i className="iconfont zfb-icon">&#xe634;</i>
                    <span className="icon-text ">支付宝</span>
                  </div>
                  <Checkbox checked={this.state.paytype} />
                </div>
              </Item>
              <Item>
                <div onClick={() => this.paytypeChange(false)} className="item">
                  <div>
                    <i className="iconfont wx-icon">&#xe63d;</i>
                    <span className="icon-text ">微信支付</span>
                  </div>
                  <Checkbox checked={!this.state.paytype} />
                </div>
              </Item>
            </List>
          </div>
        </APullToRefresh>
        <div className="flex-lvc nav-pay" onClick={() => this.goPay()}>
          {this.state.text} ￥{this.state.pay_fee}
        </div>
      </div>
    )
  }
}

export default Pay
